<template>
    <div class="cart-positions">
        <h3>{{ title }} ({{ count }})</h3>
        <div class="cart-position" v-for="(position, index) in safePositions" :key="position.id || index">
            <div v-if="position.remove" class="cart-wrapperRemove">
                <span>Вы удалили: "{{ position.name }}"</span>
                <button @click="returnPosition(index)">
                    вернуть (осталось: {{ timer }})
                </button>
            </div>
            <template v-else>
                <div class="position-left">
                    <div class="position-offerImage">
                        <div class="position-saleIcon" v-if="position.discount > 0 && config.showSaleIcon">%</div>
                        <picture v-if="position.image_jpg" class="position-offerImage-container">
                            <source media="(min-width:769px)" :srcset="position.image_webm" type="image/webp" />
                            <source media="(min-width:769px)" :srcset="position.image_jpg" />
                            <source media="(max-width:768px)" :srcset="position.image_mobile_webm" type="image/webp" />
                            <source media="(max-width:768px)" :srcset="position.image_mobile_jpg" />
                            <img class="position-offerImage" :src="position.image_jpg" :alt="position.color" :title="position.color" />
                        </picture>
                        <img v-else src="/assets/images/no-image.png" />
                    </div>
                    <div class="position-description">
                        <div class="position-name"><a target="_blank" :href="position.product_url">{{ position.name }}</a></div>
                        <div class="position-offerName"><span>Вариант:</span> {{ position.color }}</div>
                        <div class="position-positionPrice">
                            <div class="position-priceEnd">
                                {{ currency }} <span>{{ position.price }}</span>
                            </div>
                            <div v-if="position.discount > 0" class="position-priceStart">
                                {{ currency }} <span>{{ position.old_price }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="position-right">
                    <div class="position-control">
                        <button class="position-remove" @click="removePositionCart(index)">
                            <i class="far fa-trash-alt"></i>
                        </button>
                        <div class="position-count">
                            <button class="count-minus" :disabled="position.quantity == 1" @click="quantityMinus(index)">
                                <i class="fas fa-minus"></i>
                            </button>
                            <input
                                step="1" min="1" :max="position.max_quantity"
                                name="quantity"
                                title="Количество" size="4"
                                inputmode="numeric"
                                autocomplete="off"
                                disabled
                                class="input--sm quantity-position"
                                v-model="position.quantity"
                            />
                            <button class="count-plus" @click="quantityPlus(index)"><i class="fas fa-plus"></i></button>
                        </div>
                    </div>
                    <div class="position-message" v-html="position.message"></div>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
    title: {
        type: String,
        default: 'Ваши товары'
    },
    currency: {
        type: String,
        default: '₽'
    },
    positions: {
        type: Array,
        default: () => []
    },
    config: {
        type: Object,
        default: () => ({
            showSaleIcon: true,
            maxCountPosition: true,
            timeOutMessage: 5000,
            timeOutRemovePosition: 5000,
        })
    }
})

// Чтобы быть 100% уверенным, что positions — массив, даже если родитель что-то не так передал
const safePositions = computed(() => Array.isArray(props.positions) ? props.positions : [])

// Для таймера удаления
const timerRemove = ref(null)
const timer = ref(null)

const store = useStore()

const count = computed(() =>
    safePositions.value.filter(s => s.remove == false).length
)

function quantityMinus(index) {
    if (safePositions.value[index].quantity > 1) {
        safePositions.value[index].quantity--
        updateCart()
    } else {
        showMessage('Если хотите удалить, нажмите на значок корзины', index)
    }
}

function quantityPlus(index) {
    if (props.config.maxCountPosition) {
        if (safePositions.value[index].max_quantity > safePositions.value[index].quantity) {
            safePositions.value[index].quantity++
            updateCart()
        } else {
            showMessage('Это максимальное число доступное для заказа!', index)
        }
    } else {
        safePositions.value[index].quantity++
        updateCart()
    }
}

async function updateCart() {
    await store.dispatch('updateCart', safePositions.value)
    await store.dispatch('getPrice')
}

async function removePositionCart(index) {
    showRemovePosition(index)
    await store.dispatch('removePositionCart', [safePositions.value[index].offer_id])
    await store.dispatch('getPrice')
}

function showRemovePosition(index) {
    safePositions.value[index].remove = true
    timerRemove.value = setTimeout(() => safePositions.value.splice(index, 1), props.config.timeOutRemovePosition)
    startTimer()
}

function showMessage(message, index) {
    safePositions.value[index].message = message
    setTimeout(() => safePositions.value[index].message = '', props.config.timeOutMessage)
}

function returnPosition(index) {
    clearTimeout(timerRemove.value)
    safePositions.value[index].remove = false
    updateCart()
}

function startTimer() {
    timer.value = props.config.timeOutRemovePosition / 1000
    const interval = setInterval(() => {
        timer.value--
        if (timer.value <= 0) clearInterval(interval)
    }, 1000)
}
</script>
